import { useState } from 'react';
import { Alert, Button, Flex, Form, Input } from 'antd';

import useAddNote from './useAddNote';
import useFraudTemplates from 'hooks/useFraudTemplates';
import FraudTemplateFields from 'components/FraudTemplateFields/FraudTemplateFields';

const { TextArea } = Input;
const { Item } = Form;

const StickyNote = () => {
  const [form] = Form.useForm();
  const [addNote, addNoteMutation] = useAddNote();
  const [failureMessage, setFailureMessage] = useState('');

  const fraudTemplateForm = useFraudTemplates(form, 'stickyNote');

  const handleSave = async (values) => {
    try {
      await addNote({
        message: values.stickyNote,
        isSticky: true,
        category: fraudTemplateForm.createFraudSticky ? 'FRAUD' : null,
      });
      form.resetFields();
      fraudTemplateForm.reset();
    } catch (error) {
      setFailureMessage(
        'Failed to save sticky note. Please refresh the page and try again. Error: ' +
          error.message,
      );
    }
  };

  return (
    <Form
      form={form}
      layout={'vertical'}
      size="small"
      name="sticky-note-form"
      onFinish={handleSave}
    >
      {fraudTemplateForm.enabled && (
        <FraudTemplateFields fraudTemplateForm={fraudTemplateForm} />
      )}

      <Item name="stickyNote" style={{ marginBottom: 'var(--spacing-xs)' }}>
        <TextArea
          data-testid="sticky-text-area"
          autoSize={{ minRows: 4, maxRows: 20 }}
          placeholder="Sticky note"
          disabled={fraudTemplateForm.createFraudSticky}
        />
      </Item>

      {failureMessage ? (
        <Alert
          data-testid="failure-message"
          type="error"
          title={failureMessage}
          style={{ marginBottom: 'var(--spacing-xs)' }}
        ></Alert>
      ) : null}

      <Flex justify="flex-end" gap="var(--spacing-xs)" height="auto">
        <Item style={{ marginBottom: 'var(--spacing-xs)' }}>
          <Button
            data-testid="clear-button"
            onClick={() => {
              form.resetFields();
              fraudTemplateForm.reset();
            }}
          >
            Clear
          </Button>
        </Item>
        <Item style={{ marginBottom: 'var(--spacing-xs)' }}>
          <Button
            data-testid="submit-button"
            type="primary"
            loading={addNoteMutation.loading}
            htmlType="submit"
          >
            Save Sticky
          </Button>
        </Item>
      </Flex>
    </Form>
  );
};

export default StickyNote;
